import React, { useState, useEffect, useContext } from "react"
import { makeStyles } from "@material-ui/core/styles"
import {
  Box,
  Typography,
  Button,
  TextField,
  Divider,
  IconButton,
} from "@material-ui/core"
import AddShoppingCartIcon from "@material-ui/icons/AddShoppingCart"
import AddIcon from "@material-ui/icons/Add"
import RemoveIcon from "@material-ui/icons/Remove"
import BackspaceIcon from "@material-ui/icons/Backspace"
import { theme, size } from "../config.js"
import { Theme, CartContext } from "./Context"
import Quantity from "../widgets/Quantity.jsx"
import DeleteIcon from "@material-ui/icons/DeleteForever"
import TagPrice from "../widgets/TagPrice.jsx"
import search from "../lib/search"
import Img from "gatsby-image"
import ReactPixel from "react-facebook-pixel"
const useStyles = makeStyles({
  root: {
    position: "relative",
    "& .info": {
      minHeight: "30vh",
      "& .imgContainer": {
        position: "relative",
        "& .img": {
          width: "200px",
          margin: size.superBig,
        },
        "& .price": {
          position: "absolute",
          bottom: 15,
          right: 0,

          borderRadius: size.normal,
        },
      },

      // "& .totalPrice": {
      //   // position: "absolute",
      //   // bottom: "16%",
      //   // right: 0,
      //   padding: size.small,
      //   borderRadius: size.small,
      //   border: props => `1px solid ${props.turquesa}`,
      //   "& span": {
      //     position: "absolute",
      //     top: -10,
      //     background: props => props.grayLight,
      //     fontSize: ".8em",
      //   },
      // },
    },
    "& .actions": {
      width: "100%",
      position: "relative",
      "& .totalPrice": {
        background: "transparent",
        position: "absolute",
        top: -17,
        borderRadius: `${size.normal}px ${size.normal}px 0 0`,
        right: 0,
      },
    },
  },
  Variant: {
    padding: size.small,
    marginTop: size.small,
    marginRight: size.normal,
    marginBottom: size.small,
    position: "relative",
    "& .quantity": {
      position: "absolute",
      top: "50%",
      left: "0",
    },
  },
  AddQuantity: {
    position: "relative",
    "@media (max-width: 365px)": {
      marginBottom: size.big,
    },
    "& .buttonQuantity": {
      position: "absolute",
      background: props => props.turquesa,
      color: props => props.white,
    },
    "& .buttonQuantity:nth-child(1)": {
      left: -20,
    },
    "& .buttonQuantity:nth-child(3)": {
      right: -20,
    },
    "& .Quantity": {
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      width: 110,
      height: 72,
      border: props => `1px solid ${props.turquesa}`,
      borderRadius: size.normal,
      // borderRadius: "50%",
      fontSize: "1.5em",
      fontWeight: "bold",
    },
  },
})

const ProductInfo = ({
  variantName,
  variants,
  onClick,
  cancelButton,
  miniCart,
  setMiniCart,
  totalPrice,
  totalQuantity,
}) => {
  // console.log(variants)
  const color = theme(useContext(Theme))
  const classes = useStyles(color)
  const [select, setSelect] = useState(0)
  let product = variants[select]

  const searchMiniCart = select => {
    return search(miniCart, "select", select)
    // Comprueba que existe el producto con la variante actual
  }
  const handleMiniCart = (product, num) => {
    if (num > totalQuantity) {
      let exists = searchMiniCart(select)
      //Se comprueba si el producto ya fue añadido a Minicart

      if (exists) {
        let index = exists.index
        let newData = [...miniCart]
        newData.splice(index, 1, {
          ...newData[index],
          quantity: newData[index].quantity + 1,
        })
        setMiniCart(newData)
        // Si existe entonces añade +1 al quantity
      } else {
        setMiniCart([
          ...miniCart,
          {
            select,
            title: product.title,
            tag: product.tag,
            price: product.price,
            quantity: 1,
          },
        ])
        // Si No existe entonce crea el objeto en el miniCart
      }
    } else if (num < totalQuantity) {
      // Comprueba que miniCart no está vacío para evitar errores
      if (miniCart.length != 0) {
        let exists = searchMiniCart(select)
        // Se comprueba si el producto ya fue añadido
        let newData = [...miniCart]
        if (exists) {
          let index = exists.index
          let productMatch = miniCart[index]
          if (productMatch.quantity - 1 > 0) {
            // Si después de restar -1 al quantity aún queda 1
            // entonces simplemente quita -1 a quantity
            newData.splice(index, 1, {
              ...productMatch,
              quantity: productMatch.quantity - 1,
            })
            setMiniCart(newData)
          } else if (productMatch.quantity - 1 == 0) {
            // Si al restar -1 al quantity se queda en cero 0
            // Entonces borra ese producto del carrito
            newData.splice(index, 1)
            setMiniCart(newData)
          }
        }
      }
    }
  }

  let { title, img, description, tag, price } = product
  const { money } = useContext(CartContext)
  useEffect(() => {
    ReactPixel.track("ViewContent")
  }, [])
  return (
    <Box
      className={classes.root}
      display="flex"
      flexDirection="column"
      justifyContent="center"
      alignItems="center"
    >
      <Box
        className="info"
        display="flex"
        flexDirection="column"
        justifyContent="space-around"
        alignItems="center"
      >
        <Typography variant="h5">{title}</Typography>
        <div className="imgContainer">
          <Img className="img" fadeIn fluid={img.asset.fluid} alt={title} />
          <TagPrice className="price">
            {price} {money}
          </TagPrice>
        </div>

        <Typography variant="body2">{description}</Typography>
      </Box>
      <br />
      {variants.length > 1 && (
        <>
          <Box
            className={classes.Variants}
            display="flex"
            flexWrap="wrap"
            justifyContent="center"
          >
            {variants.map((p, i) => {
              return (
                <Variant
                  key={i}
                  variantProduct={searchMiniCart(i)}
                  tag={p.tag}
                  onClick={() => setSelect(i)}
                  color={select == i ? "primary" : "default"}
                  variantButton={select == i ? "contained" : "outlined"}
                />
              )
            })}
          </Box>
          <Typography variant="caption" style={{ textTransform: "uppercase" }}>
            {variantName}
          </Typography>
        </>
      )}
      <Box display="flex" justifyContent="space-around" alignItems="center">
        <Box
          className={classes.AddQuantity}
          display="flex"
          justifyContent="center"
          alignItems="center"
        >
          <IconButton
            // color="primary"
            className="buttonQuantity"
            onClick={() =>
              handleMiniCart(
                product,
                totalQuantity - 1 < 0 ? totalQuantity : totalQuantity - 1
              )
            }
          >
            <RemoveIcon />
          </IconButton>
          <Typography className="Quantity">{totalQuantity}</Typography>
          <IconButton
            // color="primary"
            className="buttonQuantity"
            onClick={() => handleMiniCart(product, totalQuantity + 1)}
          >
            <AddIcon />
          </IconButton>
        </Box>
      </Box>
      <br />
      <Box
        className="actions"
        display="flex"
        justifyContent="space-between"
        alignItems="center"
      >
        {totalPrice !== 0 && (
          <Typography className="totalPrice">
            total: {totalPrice}
            {money}
          </Typography>
        )}
        <IconButton onClick={cancelButton}>
          <DeleteIcon color="primary" fontSize="large" />
        </IconButton>
        {totalQuantity !== 0 ? (
          <Button
            onClick={() => {
              ReactPixel.track("AddToCart", {
                value: totalPrice,
                currency: money == "Bs" ? "BOB" : money,
              })
              onClick()
            }}
            fullWidth
            variant="contained"
            color="secondary"
          >
            <AddShoppingCartIcon />
            Añadir
          </Button>
        ) : (
          <Button variant="contained" disabled fullWidth>
            <AddShoppingCartIcon />
            Añadir
          </Button>
        )}
      </Box>
    </Box>
  )
}
export const Variant = ({
  tag,
  variantProduct,
  onClick,
  color,
  variantButton,
}) => {
  const classes = useStyles()
  let quantity = 0
  if (variantProduct) {
    quantity = variantProduct.quantity
  }
  return (
    <>
      {tag && (
        <Button
          className={classes.Variant}
          size="small"
          onClick={onClick}
          color={color}
          variant={variantButton}
          component="div"
        >
          {tag}
          {quantity !== 0 && (
            <Quantity quantity={quantity} className="quantity" />
          )}
        </Button>
      )}
    </>
  )
}

export default ProductInfo
